{
  "chart": {
    "how-to-measure": "採寸方法",
    "select-your-size-we-ll-notify-you-once-it-s-back-in-stock": "サイズを選択してください。再入荷したらお知らせします"
  },
  "page": {
    "plans": {
      "try-now": "今すぐ試す",
      "what-included": "含まれる内容は?",
      "popular-plan": "人気"
    },
    "about-us": {
      "title": "会社概要",
      "intro": "Goodchartは2023年に、あなたの洋服ショッピング体験を変革するというミッションのもとに誕生しました。ファッション愛好家、デザイナー、テクノロジーの専門家からなる私たちのチームが、あなたの体型に本当にフィットする洋服を見つけるお手伝いをします。使いやすいインターフェースと高度なアルゴリズムにより、あなたの採寸データ、スタイル、ライフスタイルに基づいたパーソナライズされた推奨を提供します。",
      "community": "妥協にさよならを告げ、自信と快適さに出会いましょう。満足しているお客様の包括的なコミュニティに参加し、Goodchartと共に喜びに満ちたショッピングの旅へ出かけましょう。",
      "tagline": "あなたのスタイルを解き放とう。純粋なファッションの高揚感を体験しよう。",
      "founders": "創業者",
      "cedric-photo-alt": "Cedric、Goodchart共同創業者兼プロダクト責任者",
      "nick-photo-alt": "Nick、Goodchart共同創業者兼オペレーション責任者",
      "quentin-photo-alt": "Quentin、Goodchart情報技術責任者",
      "cedric": "Cedric",
      "cedric-role": "Goodchart共同創業者兼プロダクト責任者",
      "nick": "Nick",
      "nick-role": "Goodchart共同創業者兼オペレーション責任者",
      "quentin": "Quentin",
      "quentin-role": "Goodchart情報技術責任者"
    },
    "contact": {
      "title": "お問い合わせ",
      "lets-talk": "お話ししましょう",
      "subtitle": "フォームにご記入いただくと、当社チームがメールでご連絡いたします。",
      "first-name": "名",
      "first-name-required": "名は必須です",
      "last-name": "姓",
      "last-name-required": "姓は必須です",
      "email": "メールアドレス",
      "email-required": "メールアドレスは必須です",
      "email-invalid": "有効なメールアドレスを入力してください",
      "message": "メッセージ",
      "message-required": "メッセージは必須です",
      "sending": "送信中...",
      "send": "送信",
      "success": "フォームが当社チームに送信されました!"
    },
    "email-unsubscribe": {
      "title": "メール登録",
      "unsubscribe-confirm": "メーリングリストの登録を解除してもよろしいですか?",
      "unsubscribe-info": "登録を解除すると、今後、最新情報、ニュースレター、特別オファーを受け取ることができなくなります。",
      "cancel": "キャンセル",
      "confirm-unsubscription": "登録解除を確認",
      "resubscribe-confirm": "メーリングリストに再登録しますか?",
      "resubscribe-info": "最新情報、限定オファー、注目のアップデートをお届けします。",
      "resubscribe": "再登録する",
      "unsubscribe-success": "メールの登録解除が完了しました",
      "unsubscribe-error": "メールの登録解除中に問題が発生しました",
      "resubscribe-success": "メールの再登録が完了しました",
      "resubscribe-error": "メールの再登録中に問題が発生しました"
    },
    "back-to-stock": {
      "notify-me-product": "商品 {{title}} - {{variant}} について通知する"
    },
    "help": {
      "title": "ヘルプセンター",
      "description": "ShopifyストアでGoodchartを設定・利用するためのガイドです。",
      "search": "ヘルプ記事を検索",
      "loading": "読み込み中…",
      "load-failed": "ヘルプセンターを読み込めませんでした。しばらくしてからもう一度お試しください。",
      "no-results": "検索に一致する記事はありません。",
      "no-articles": "ヘルプ記事はまだありません。",
      "topics": {
        "getting-started": "はじめに",
        "size-charts": "サイズチャート",
        "table-charts": "テーブルチャート",
        "assigning-products": "商品の割り当て",
        "storefront-display": "ストアでの表示",
        "chart-import": "チャートのインポート",
        "size-recommendations": "サイズのおすすめ",
        "plans-billing": "プランと請求",
        "troubleshooting": "トラブルシューティング"
      },
      "back": "ヘルプセンターに戻る",
      "browse": "ヘルプセンターを見る",
      "not-found": {
        "title": "記事が見つかりません",
        "description": "この記事は存在しないか、現在は公開されていません。"
      },
      "updated": "最終更新日: {{date}}",
      "related": "{{topic}}の他の記事",
      "contact": {
        "title": "解決しませんでしたか？",
        "description": "メッセージをお送りいただければ、担当チームからメールでご連絡します。Goodchartアプリをインストール済みの場合は、アプリ内のサポートチャットでもご質問いただけます。",
        "link": "お問い合わせ"
      },
      "article-load-failed": "この記事を読み込めませんでした。しばらくしてからもう一度お試しください。"
    }
  },
  "error": {
    "error-occurred": "エラーが発生しました!",
    "failed-to-subscribe-to-this-product": "この商品の登録に失敗しました!",
    "failed-to-get-your-size-recommendation-please-try-again-later": "サイズ推奨の取得に失敗しました。後でもう一度お試しください。"
  },
  "common": {
    "close": "閉じる"
  },
  "component": {
    "size-recommender": {
      "form": {
        "title": "最適なサイズを見つける",
        "subtitle": "より良いフィット感のためのいくつかの簡単な項目",
        "shopping-for": "お探しの対象",
        "gender-women": "女性",
        "gender-men": "男性",
        "gender-other": "その他",
        "measurements": "採寸",
        "height": "身長",
        "height-required": "身長は必須です",
        "height-min": "最小身長は1です",
        "weight": "体重",
        "weight-required": "体重は必須です",
        "weight-min": "最小体重は1です",
        "preferred-fit": "希望のフィット感",
        "continue": "続ける"
      },
      "result": {
        "suggested-size": "推奨サイズ:",
        "no-fit": "申し訳ございませんが、現在理想的なサイズがないようです。後日改めてご確認ください。",
        "verdict": "判定:",
        "similar-variants": "類似のバリエーション:",
        "proceed": "このバリエーションで進める",
        "estimate-disclaimer": "(ブランドおよびユーザー情報に基づく推定値であり、結果は異なる場合があります。)",
        "back": "戻る"
      }
    },
    "footer": {
      "terms": "利用規約",
      "privacy": "プライバシー",
      "help-center": "ヘルプセンター",
      "blog": "ブログ",
      "about": "会社概要",
      "contact-us": "お問い合わせ"
    },
    "conversion-table": {
      "description": "フィット感によって、採寸に若干の違いが生じる場合があります。以下のチャートで正しいサイズをお探しください。",
      "size": "サイズ"
    },
    "add-to-cart-btn": {
      "notify-me-when-available": "入荷したら通知する",
      "notify-me": "通知する",
      "out-of-stock": "在庫切れ"
    },
    "restock-form": {
      "your-name": "お名前",
      "your-email": "メールアドレス",
      "email-required": "メールアドレスは必須です",
      "subscribing": "登録中...",
      "notify-me": "通知する",
      "agree-terms": "続行することで、以下に同意したものとみなされます:",
      "terms-privacy": "利用規約およびプライバシーポリシー",
      "news-opt-in": "新商品の発売やその他の刺激的なコンテンツに関する最新情報を受け取りたい (任意)"
    },
    "back-to-stock-result": {
      "new-subscription": "ありがとうございます。サイズ<span class=\"font-bold\">{{name}}</span>が入荷したらメールでお知らせします。",
      "existing-subscription": "メールアドレスは既に登録済みです!サイズ<span class=\"font-bold\">{{name}}</span>が再入荷したらすぐにお知らせします。",
      "back-to-collection": "コレクションに戻る"
    },
    "chart": {
      "find-your-size": "サイズを見つける",
      "size-guide": "サイズガイド",
      "recommendation": "おすすめ",
      "body-measurements": "身体寸法",
      "model-measurements": "モデル寸法",
      "model-description": "モデル {{name}} は身長{{height}}cmで、サイズ{{variant}}を着用しています。",
      "size-conversion": "サイズ換算"
    },
    "landing": {
      "learn": "学ぶ",
      "learn-more": "詳しく見る",
      "blog": "ブログ",
      "blog-description": "最新のお知らせ、商品アップデートなどをご覧ください",
      "help-center": "ヘルプセンター",
      "help-center-description": "はじめに、ハウツー記事、ステップバイステップの手順",
      "demo": "デモ",
      "demo-description": "サンプルストアでGoodsizeウィジェットの動作をご覧ください",
      "services": "サービス",
      "contact": "お問い合わせ",
      "privacy": "プライバシー",
      "goodsize": "Goodsize",
      "goodsize-description": "あなたのビジネス向けフィッティングソリューションをご紹介します",
      "goodchart": "Goodchart",
      "goodchart-description": "コンバージョンを高めるビジュアルサイズチャート"
    },
    "product-variant-completer": {
      "title": "オプションを選択してください",
      "body": "続けるには{{option}}を選択してください。",
      "body-multiple": "続けるには残りのオプションを選択してください。",
      "body-notify": "どの{{option}}の入荷をお知らせしましょうか？",
      "confirm": "次へ",
      "cancel": "キャンセル",
      "empty": "この組み合わせは購入できません。"
    },
    "checkout-variant": {
      "label": "{{variant}} を購入します",
      "aria-label": "購入するバリエーションを変更",
      "sold-out": "在庫切れ"
    }
  },
  "promotion": {
    "BlackFriday": {
      "name": "ブラックフライデー"
    }
  }
}
